<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="tanker_truck.truck_id && tanker_truck.truck_id > 0"
                                @invoke-method="dbGetTankerTruck(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="tanker_truck.truck_id && tanker_truck.truck_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('tanker_trucks.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in tanker_truck_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != tanker_truck.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('tanker_trucks.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_tanker_truck.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'tanker_trucks' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="tanker_truck.status" class="ribbon ribbon-top-right" :class="`ribbon-${tanker_truck.status_class}`"><span class="ribbon-span">{{ tanker_truck.status }}</span></div>
                        <v-form ref="formTankerTruck">
							<v-flex xs12>
								<v-text-field
									v-focus="tanker_truck_dialog"
									v-model="tanker_truck.truck_id"
									:label="`${$t('lang.truck_id')} *`"
									:counter="showCounter(tanker_truck.truck_id, 'tanker_trucks.truck_id')"
									:rules="ifValid('tanker_trucks.truck_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="tanker_truck.company_id"
									:label="$t('lang.company_id')"
									:items="customers"
									item-value="company_id"
									item-text="company"
									:rules="ifValid('tanker_trucks.company_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.truck_name"
									:label="`${$t('lang.truck_name')} *`"
									:counter="showCounter(tanker_truck.truck_name, 'tanker_trucks.truck_name')"
									:rules="ifValid('tanker_trucks.truck_name')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.max_weight"
									:label="`${$t('lang.max_weight')} *`"
									:counter="showCounter(tanker_truck.max_weight, 'tanker_trucks.max_weight')"
									:rules="ifValid('tanker_trucks.max_weight')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.compartment1"
									:label="`${$t('lang.compartment1')} *`"
									:counter="showCounter(tanker_truck.compartment1, 'tanker_trucks.compartment1')"
									:rules="ifValid('tanker_trucks.compartment1')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.compartment2"
									:label="`${$t('lang.compartment2')} *`"
									:counter="showCounter(tanker_truck.compartment2, 'tanker_trucks.compartment2')"
									:rules="ifValid('tanker_trucks.compartment2')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.compartment3"
									:label="`${$t('lang.compartment3')} *`"
									:counter="showCounter(tanker_truck.compartment3, 'tanker_trucks.compartment3')"
									:rules="ifValid('tanker_trucks.compartment3')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.compartment4"
									:label="`${$t('lang.compartment4')} *`"
									:counter="showCounter(tanker_truck.compartment4, 'tanker_trucks.compartment4')"
									:rules="ifValid('tanker_trucks.compartment4')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.compartment5"
									:label="`${$t('lang.compartment5')} *`"
									:counter="showCounter(tanker_truck.compartment5, 'tanker_trucks.compartment5')"
									:rules="ifValid('tanker_trucks.compartment5')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="tanker_truck.num_of_compartments"
									:label="`${$t('lang.num_of_compartments')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('tanker_trucks.num_of_compartments')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="tanker_truck.driver_id"
									:label="$t('lang.driver_id')"
									:items="driver_id"
									item-value="value"
									item-text="text"
									:rules="ifValid('tanker_trucks.driver_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.serial"
									:label="$t('lang.serial')"
									:counter="showCounter(tanker_truck.serial, 'tanker_trucks.serial')"
									:rules="ifValid('tanker_trucks.serial')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.meter_style"
									:label="`${$t('lang.meter_style')} *`"
									:counter="showCounter(tanker_truck.meter_style, 'tanker_trucks.meter_style')"
									:rules="ifValid('tanker_trucks.meter_style')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="tanker_truck.vehicle_type"
									:label="$t('lang.vehicle_type')"
									:counter="showCounter(tanker_truck.vehicle_type, 'tanker_trucks.vehicle_type')"
									:rules="ifValid('tanker_trucks.vehicle_type')"
								></v-text-field>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'tanker_trucks' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveTankerTrucks">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_tanker_truck"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_tanker_truck')"
                :message="$t('lang.delete_tanker_truck_confirm')"
                @onConfirm="deleteTankerTrucks()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_tanker_truck_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteTankerTruckDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            tanker_truck: { },
            file_name: "",
            dbGetTankerTruck: _.debounce(this.getTankerTruck, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchTankerTruck", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.tanker_truck) {
                        this.tanker_truck = this.assignObj2(data.tanker_truck, this.rules_tanker_trucks);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=tanker_truck_status&sort_by=2",
                            method: "get",
                            stateProperty: "tanker_truck_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "tanker_trucks", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchTankerTruck", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.tanker_truck) {
                        next((vm) => {
                            vm.tanker_truck = vm.assignObj2(data.tanker_truck, vm.rules_tanker_trucks);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=tanker_truck_status&sort_by=2",
                                method: "get",
                                stateProperty: "tanker_truck_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "tanker_trucks", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=tanker_truck_status&sort_by=2",
            method: "get",
            stateProperty: "tanker_truck_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_tanker_trucks: (state) => state.tanker_trucks.rules_tanker_trucks,
            tanker_truck_status_options: (state) => state.settings.tanker_truck_status_options,
            tanker_trucks: (state) => state.tanker_trucks.tanker_trucks,
            selectedTankerTruck: (state) => state.tanker_trucks.selectedTankerTruck,

        }),
    },
    methods: {
        ...mapActions([
            "fetchTankerTruck",
            "saveTankerTruck",
            "deleteTankerTruck",
            "printTankerTruck",
			"fetchCustomers",

        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getTankerTruck(pg_refresh = false) {
            this.startLoader();

            this.fetchTankerTruck({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.tanker_truck) {
                    this.tanker_truck = this.assignObj2(data.tanker_truck, this.rules_tanker_trucks);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printTankerTruck({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.tanker_truck) {
                    if (this.dev_mode) {
                        this.file_name = data.tanker_truck.file_name;
                    } else {
                        this.$refs.print.printReport(data.tanker_truck.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveTankerTrucks() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formTankerTruck")) {
                    let body = this.prepForm(this.tanker_truck, this.rules_tanker_trucks);

                    this.saveTankerTruck({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.tanker_truck) {
                            this.$router.push({ name: "tanker_truck", params: { id: data.tanker_truck.truck_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { truck_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveTankerTrucks({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.tanker_truck) {
                    this.tanker_truck = this.assignObj2(data.tanker_truck, this.rules_tanker_trucks);
                }
            });
        },
        deleteTankerTrucks() {
            this.deleteTankerTruck({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {

                    this.validationOff();
                    this.$router.push({ name: "tanker_trucks" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force=false) {
            this.startLoader();

            if (force == true) {
                await this.fetchTankerTruck({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.tanker_truck) {
                        this.tanker_truck = this.assignObj2(data.tanker_truck, this.rules_tanker_trucks);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

if (this.customers === null || force == true) await this.getCustomers();

        },
    },
    mounted() {
        this.refresh();
    },
    created() {
    },
};
</script>
